<template>
  <div v-for="opt in mapOptions" :key="opt.id" class="pe-option-container">

    <label v-if="opt.show_title" :class="[globalConfig.classes?.label]">
      {{ opt.title }}
    </label>

    <MapaLocationComponent :center="initialCenter" :positionReceived="opt.value"
      :setTextInput="(lat, lng) => handleMapUpdate(opt.id, lat, lng)" class="pe-map-custom" />

  </div>
</template>

<script setup>
import MapaLocationComponent from '../Shared/MapLocation.vue';
import { computed, inject } from 'vue';

const props = defineProps({
  question: { type: Object, required: true },
});

const engine = inject('formEngine');
const globalConfig = inject('engineConfig');

const initialCenter = computed(() => {
  return globalConfig?.value?.mapCenter || { lat: -31.647, lng: -63.344 };
});

// Filtramos solo las opciones de este grupo
const mapOptions = computed(() => {
  return props.question.optionGroups['map'] || [];
});

// Callback que conecta Mapa -> Engine
const handleMapUpdate = (optionId, lat, lng) => {
  // Formateamos como string "lat,lng" que es lo que espera tu lógica vieja
  const value = `${lat},${lng}`;
  engine.setAnswer(props.question.id, optionId, value);
};
</script>

<style scoped>
.pe-map-custom {
  width: 100%;
  height: var(--pe-map-height, 57.596vh);
  border-radius: var(--pe-option-border-radius, 0.5rem);
  overflow: hidden;
}
</style>